import React from 'react'
import { Card, CardContent, CardHeader, Paper, makeStyles, styled } from '@material-ui/core'

export const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  padding: 16,

  '& > *': {
    margin: 16,
    flexGrow: 1,
  },
})

export const FormRow = styled('span')({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
  justifyContent: 'space-between',
  margin: 0,

  '& > *': {
    margin: 16,
    flexGrow: 1,
  },
})

export const FormSection = ({
  title,
  children,
  className,
  action,
}: {
  title: string
  children?: JSX.Element[]|JSX.Element
  className?: string
  action?: any
}) => {
  const { card } = useStyles()
  return <Card className={card} elevation={0} variant="outlined">
    <CardHeader title={title} action={action} classes={{ action: 'act' }} />
    <CardContent className={className}>{children}</CardContent>
  </Card>
}

export const FormGroup = ({ title, children }: { title: string, children: any }) => {
  return <Paper variant="outlined">
    <CardHeader title={title} />
    {children}
  </Paper>
}

const useStyles = makeStyles({
  card: {
    margin: '16px 6px',

    '& .act': {
      margin: 0,
    },
  },
})
